<button mat-menu-item
    [ngClass]="{ 'cm-main-menu__item--active': currentPage === NAVIGATION_VIEWS.RANCHES }"
    (click)="navigateToMyRanches()">
    <span class="cm-svg-icon cm-svg-icon--menu-items cm-svg-icon--thick">
        <svg-ranch-marker></svg-ranch-marker>
    </span>
    <span>{{'My Ranches' | translate }}</span>
</button>
<button mat-menu-item
    *ngIf="user && user.Roles && user.Roles[0] && user.Roles[0].Id == 1"
    [ngClass]="{ 'cm-main-menu__item--active': currentPage === NAVIGATION_VIEWS.LOCALIZATION }"
    (click)="navigateToAdministration()">
    <mat-icon style="margin-top:-3px;">admin_panel_settings</mat-icon>{{'Admin' | translate }}
</button>
<button mat-menu-item
    (click)="logout()">
    <mat-icon>logout</mat-icon>{{'Log Out' | translate }}
</button>
<mat-divider></mat-divider>
<button mat-menu-item
    (click)="openDonationLink()">
    <mat-icon>volunteer_activism</mat-icon>{{'Donate' | translate }}
</button>
<button mat-menu-item
    (click)="openDiscordLink()">
    <mat-icon>group</mat-icon>{{'Join Our Discord' | translate }}
</button>